<div class="mb-carousel flex-row flex-gap-24 flex-center">
  <!-- PREVIOUS -->
  @if (showPrevious === true && entities?.length > 1) {
    <div class="mb-carousel__previous">
      <div class="mb-carousel__previous__container" (click)="previous()">
        <img src="/assets/images/back.png" alt="Previous" />
      </div>
      <!-- /mb-carousel__previous__container -->
    </div>
  }
  <!-- /mb-carousel__previous -->

  <!-- CONTENT -->
  <div class="mb-carousel__content">
    <!-- DEFAULT TEMPLATE REF -->
    <ng-template #defaultRowTemplate let-entity>
      {{ entity }}
    </ng-template>

    <div class="mb-carousel__content__tabs-container">
      <mat-tab-group
        [selectedIndex]="selectedIndex"
        (selectedIndexChange)="selectedIndex = $event"
        #carousel
        class="mb-carousel__content__tabs"
        [mat-stretch-tabs]="false"
      >
        @for (entity of entities; track entity; let i = $index) {
          <mat-tab>
            <!-- PASSED IN TEMPLATE -->
            @if (!IsNullOrUndefined(row?.template)) {
              <ng-container
                *ngTemplateOutlet="row.template; context: { $implicit: entity, index: i }"
              ></ng-container>
            } @else {
              <ng-container
                *ngTemplateOutlet="defaultRowTemplate; context: { $implicit: entity, index: i }"
              >
              </ng-container>
            }
            <!-- DEFAULT TEMPLATE -->
          </mat-tab>
        }
      </mat-tab-group>
      <!-- /mb-carousel__content__tabs -->
    </div>
    <!-- /mb-carousel__content__tabs-container -->

    @if (showNavigationItems === true) {
      <div class="mb-carousel__content__navigation-container">
        <div class="mb-carousel__content__navigation flex-row">
          @for (entity of entities; track entity; let i = $index) {
            <div (click)="show(i)" class="mb-carousel__content__navigation__item-container">
              <div
                [ngClass]="{
                  'mb-carousel__content__navigation__item': true,
                  'mb-carousel__content__navigation__item--active': selectedIndex === i,
                }"
              ></div>
            </div>
          }
        </div>
        <!-- /mb-carousel__content__navigation -->
      </div>
    }
    <!-- /mb-carousel__content__navigation-container -->
  </div>
  <!-- /mb-carousel__content -->

  <!-- NEXT -->
  @if (showNext === true && entities?.length > 1) {
    <div class="mb-carousel__next">
      <div class="mb-carousel__next__container" (click)="next()">
        <img src="/assets/images/back.png" alt="Previous" />
      </div>
      <!-- /mb-carousel__next__container -->
    </div>
  }
  <!-- /mb-carousel__next -->
</div>
<!-- /mb-carousel -->
